import { createModalHook } from '../../hooks/useModal'

export const useEditLanguageModal = createModalHook()
